import DirectorsConsentContentSucess from 'modules/Business/containers/DirectorsSuccess/ContentDefault';

const DirectorConsentSuccess = ({ completeOnboarding }: { completeOnboarding: () => void }) => {
  return <DirectorsConsentContentSucess completeOnboarding={completeOnboarding} />;
};

export default DirectorConsentSuccess;
